import { DataStore, ItemReference, DataModel, Query, QueryResult, ItemModel } from 'src/core/stores/dataStore';
import { FormStore, FormModel } from 'src/core/stores/formStore';
import { repository, AsyncAction, reduce } from 'redux-scaffolding-ts';
import { container } from 'src/inversify.config';
import { Validator } from "lakmus";
import { CommandResult } from '../core/stores/types';
import HttpService from '../core/services/http.service';
import { ProjectMemberBasicSummary, ProjectMemberSummary } from './projectmembers-store';
import { ProjectTaskBasicSummary, ProjectTaskSummary } from './projecttasks-store';
import { Moment } from 'moment';
import moment from 'moment-timezone';
import { unixEpochToDate } from '../core/utils/object';

export interface LogItem {
    id: number
    type: string
    data: any
    dateTimeStamp: number
    userId: string
    userDisplayName: string
}

export interface ExpandedLogItem {
    id: number
    type: string
    data: any
    dateTimeStamp: number
    dateTime: Moment
    userId: string
    userDisplayName: string
    managerDisplayName?: string
    projectTitle?: string
    taskTitle?: string
    timesheetValue?: string
    comment?: string
    day?: string
    actionComment?: string
    isPublication: boolean
    isApproval: boolean
    isReject: boolean
    timesheetDay?: string
}

export function ExpandLogItem(log: ExpandedLogItem): ExpandedLogItem {
    log.dateTime = moment.unix(log.dateTimeStamp).utc()
    let data = JSON.parse(log.data)
    log.data = data

    try {
        log.managerDisplayName = data.ManagerDisplayName
    } catch (e) {
        log.managerDisplayName = undefined
    }

    try {
        log.projectTitle = data.ProjectTitle
    } catch (e) {
        log.projectTitle = undefined
    }

    try {
        log.taskTitle = data.TaskTitle
    } catch (e) {
        log.taskTitle = undefined
    }

    try {
        log.timesheetValue = data.Value
    } catch (e) {
        log.timesheetValue = undefined
    }

    try {
        log.comment = data.Comment
    } catch (e) {
        log.comment = undefined
    }

    try {
        log.day = data.Day
    } catch (e) {
        log.day = undefined
    }

    try {
        log.actionComment = data.ActionComment
    } catch (e) {
        log.actionComment = undefined
    }

    try {
        log.isPublication = data.IsPublication ? true : false
        log.type = (data.IsPublication) ? "TimesheetPublished" : log.type
    } catch (e) {
        log.isPublication = false
    }

    try {
        log.isApproval = data.IsApproval ? true : false
        log.type = (data.IsApproval) ? "TimesheetApproved" : log.type
    } catch (e) {
        log.isApproval = false
    }

    try {
        log.isReject = data.IsReject ? true : false
        log.type = (data.IsReject) ? "TimesheetRejected" : log.type
    } catch (e) {
        log.isReject = false
    }

    var splitted = log.type.split('.');
    var result = splitted[splitted.length-1].replace(/([A-Z])/g, " $1");
    log.type = result.charAt(0).toUpperCase() + result.slice(1);
    log.type = log.type.trim()

    if (log.type == "Timesheet Entry Updated") {
        var fromDate = moment(unixEpochToDate(log.data["fromDate"])).utc()
        var toDate = moment(unixEpochToDate(log.data["toDate"])).utc()
        var day = parseInt(log.day!)-1
       
        if (day < 6) {
            var firstDayOfYear = moment((new Date(toDate.year(), 0, 1)))
            log.timesheetDay = firstDayOfYear.add(day, "days").format("DD-MM-YYYY")
        }
        else {
            var firstDayOfYear = moment((new Date( fromDate.year(), 0, 1)))
            log.timesheetDay = firstDayOfYear.add(day, "days").format("DD-MM-YYYY")
        }
      
    }
    
    return log
}

@repository("@@LOGS", "Logs.summary")
export class LogsStore extends DataStore<ExpandedLogItem> {
    baseUrl: string = ``;
    ENTITY_LIST_UPDATE_CUSTOM: string;

    constructor() {
        super('LOG', {
            count: 0,
            isBusy: false,
            items: [],
            result: undefined,
            discard: item => { }
        }, container);

        //set custom reducer
        this.ENTITY_LIST_UPDATE_CUSTOM = `LOG_LIST_UPDATE_CUSTOM`;
        this.addReducer(this.ENTITY_LIST_UPDATE_CUSTOM, (): any => {
            return {
                onStart: () => ({ ...this.state, isBusy: true }),
                onSuccess: (value: ExpandedLogItem) => {
                    return {
                        ...this.state,
                        isBusy: false,
                        count: value.data.count,
                        result: undefined,
                        items: (value.data.items || []).map((item: ExpandedLogItem) => ({
                            state: 'Unchanged',
                            isBusy: false,
                            item: ExpandLogItem(item),
                            result: undefined,
                        }) as ItemModel<ExpandedLogItem>)
                    };
                },
                onError: (error: any) => ({
                    ...this.state, isBusy: false, result: error && error.response && error.response.data && error.response.data.messages ? error.response.data : {
                        isSuccess: false,
                        items: [],
                        count: 0,
                        messages: [{ body: error.message || error, level: 'Error' }]
                    }
                })
            };
        }, 'AsyncAction');
    }

    public changeUrl(companyId: string) {
        this.baseUrl = `${process.env.PUBLIC_URL}/api/v1/companies/${companyId}/logs`;
    }

    public async getAllAsync(query: Query, data?: any): Promise<QueryResult<ExpandedLogItem>> {
        let httpService = this.container.get<HttpService>(HttpService);
        const result = await this.dispatchAsync(this.ENTITY_LIST_UPDATE_CUSTOM as string, httpService.get<QueryResult<ExpandedLogItem>>(`${this.baseUrl}?${DataStore.buildUrl(query)}`, data))
        return result.data;
    }

    public async getReportsAsync(query: Query,data?: any) {
        var downloadUrl = this.baseUrl + '/report';

        let httpService = this.container.get<HttpService>(HttpService);
        const result = await this.dispatchAsync(this.ENTITY_LIST_UPDATE as string, httpService.get<ExpandedLogItem>(`${downloadUrl}?${DataStore.buildUrl(query)}`, data));
        return result;
    }
}